import React, { Component } from "react";
import LicensesInUseList from "../LicensesInUseList/index";

class LicensesInUsePanel extends Component {
  constructor(props) {
    super(props);
    this.state = { stores: props.stores };
  }

  componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    await this.state.stores.data.LicensesInUseStore.fetchByCustomerId(
      this.state.stores.currentUser.customer.Id
    );
    await this.state.stores.data.UsersStore.fetchByCustomerId(
      this.state.stores.currentUser.customer.Id
    );

    this.setState({
      licensesInUse: this.state.stores.data.LicensesInUseStore._data,
      users: this.state.stores.data.UsersStore._data
    });
  }

  render() {
    return (
      <div className="col-sm-12">
        <div className="well">
          <h2>Licenses in use</h2>
          <LicensesInUseList licensesInUse={this.state.licensesInUse} />
        </div>
      </div>
    );
  }
}

export default LicensesInUsePanel;



// WEBPACK FOOTER //
// ./src/Components/LicensesInUsePanel/LicensesInUsePanel.js